import React from 'react';
import { HeaderProps } from '../../interfaces';
import AccountQrModal from '../../AccountQrModal';
import useDfcVillageHeader from '../../hooks/useDfcVillageHeader';
import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';
import CartHoldCountdown from './CartHoldCountdown';
import useDfcDocumentSurface from '../../hooks/useDfcDocumentSurface';
import useFitnessVillageCopy from '../../../../../hooks/useFitnessVillageCopy';
import { ASA_HEADER_SURFACE_LIGHT, isAsaCompany } from '../../../../../Utils/asaBrand';

/**
 * Header for the DFC Fitness Village theme (`company.theme === 'dfcVillageTheme'`).
 *
 * Implements the sticky header from the "Dubai Fitness Challenge booking theme" design:
 * the compact lockup + theme orb + sign-in + menu bar under 960px, and the full nav with the
 * day / night switch and a sign-in pill above it. Both read the surface from
 * `DfcThemeModeContext`, which the switch sets. A
 * thin `CartHoldCountdown` strip appears under the bar whenever the shared cart timer is
 * running — the Phase 1 deferral resolved in Phase 5 (§8.4).
 */
const HeaderDfcVillage: React.FC<HeaderProps> = ({ company, toggleDrawer }) => {
  const state = useDfcVillageHeader(company);
  useDfcDocumentSurface(state.surface);
  const copy = useFitnessVillageCopy().header;
  // All Sports Arena's light header is its site's blue bar; the page below keeps its own surface.
  const barState =
    isAsaCompany(company) && !state.surface.dark
      ? { ...state, surface: ASA_HEADER_SURFACE_LIGHT }
      : state;

  return (
    <>
      {state.isDesktop ? (
        <DesktopHeader state={barState} />
      ) : (
        <MobileHeader state={barState} toggleDrawer={toggleDrawer} />
      )}
      <CartHoldCountdown surface={state.surface} countdownApi={state.countdownApi} />
      <AccountQrModal
        open={state.isAccountQrModalOpen}
        onClose={state.handleCloseAccountQrModal}
        qrCodeValue={state.qrCodeValue}
        onViewProfile={state.handleViewProfileFromQrModal}
        labels={copy.qrModal}
      />
    </>
  );
};

export default HeaderDfcVillage;
